import { render, staticRenderFns } from "./No17.vue?vue&type=template&id=96d63df0&scoped=true"
import script from "./No17.vue?vue&type=script&lang=js"
export * from "./No17.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d63df0",
  null
  
)

export default component.exports